// features/exampleFeature/ui/ExampleModal.tsx
import React from 'react';
import styled from 'styled-components';
import { Subtitle1, TextMedium } from '../../../shared/ui';
import { colors } from '../../../shared/styles/colors';
import { NavigateFunction } from 'react-router-dom';
import { modalStore } from 'entities/modal/model/modal.store';

interface AdditionalData {
  purchase_pack_id: number;
  purchase_pack_title: string;
}

type NotificationModalProps = {
  title?: string;
  message?: string;
  icon?: string;
  additional_data: AdditionalData;
  navigate: NavigateFunction;
};

const ModalWrapper = styled.div`
    padding: 8px 0px;
    display: flex;
    flex-direction: column;
    width: 690px;
    height: 574px;
    gap: 20px;
`

  const PriceContainer = styled.div`
  background: ${colors.accentTertiary};
  display: flex;
  border-radius: 100px;
  padding: 9px 25px 12px;
  color: ${colors.accentPrimary};
  font-weight: 500;
  width: fit-content;
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  &:hover {
    background: #7db0e9;
  }
`;

const ActionRow = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 10px;
  margin-left: 15px;
  gap: 16px;
`;

export const NotificationModal: React.FC<NotificationModalProps> = ({title, message, icon, additional_data, navigate}) => {

  const handleTestNavigation = (notification : AdditionalData) => {
    if (!notification.purchase_pack_id || !notification.purchase_pack_title) return;
      navigate(`/Навчання/${"1"}/${notification.purchase_pack_id}`);
      modalStore.closeModal()
  }

  return (
    <ModalWrapper>
      <div className="flex mr-2 items-center">
        <img src={icon} alt="notification"/>
        <Subtitle1 color={colors.accentPrimary}>{title}</Subtitle1>
      </div>

      <TextMedium className='ml-5' color={colors.accentQuaternary6}>{message}</TextMedium>
      {additional_data?.purchase_pack_id && (
                  <ActionRow onClick={(e)=>{e.stopPropagation()}}>
                    <PriceContainer
                    //@ts-ignore
                      onClick={() => handleTestNavigation(additional_data)}
                      className="w-full text-center justify-center"
                    >
                      Пройти тестування
                    </PriceContainer>
                  </ActionRow>
                )}
    </ModalWrapper>
  );
};
